




































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import ListState from '../../../store/modules/list-state'
import AbpBase from '@/lib/abpbase'
import AppConsts from '@/lib/appconst';
import InventoryAgingReportOutput from '@/store/entities/inventory-aging-output';
import InventoryAgingReportItem from '@/store/entities/inventory-aging-item';
import columns from './inventory-aging-columns';
import opsColumns from './ops-inventory-aging-columns';
import clientColumns from './client-inventory-aging-columns';
import ProductForSelect from '@/store/entities/products/product-for-select'
import _ from 'lodash';
class  PageInventoryAgingReportRequest{
    warehouseCode: string="";
    clientCode:string="";
    sku:string="";
     type: number;
}
@Component
export default class InventoryAgingReport extends  AbpBase{
    //filters
    pagerequest:PageInventoryAgingReportRequest=new PageInventoryAgingReportRequest();
    clients =[];
    warehouses=[];
    reportResult : InventoryAgingReportOutput= new InventoryAgingReportOutput();
    dataPage : ListState<InventoryAgingReportItem>={
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<InventoryAgingReportItem>(),
        loading: false,
    };
    objectLoading :boolean=false;
    productName:string="";
    products : Array<ProductForSelect> = new Array<ProductForSelect>();
    searchProduct_OnPress =   _.debounce(this.searchProductForSelect, AppConsts.debounceDelayTime, {
        leading: false,
        trailing: true,
    });
    isClient() {
      return this.$store.state.session.client != null;
    }
    isTenant() {
      return this.$store.state.session.tenant!=null;
    }
    async getWarehouses(){
         await this.$store.dispatch({
            type:'warehouse/getListForSelect',
            data: { hasAllItem: true}
        }).then(()=>{
          var re = this.$store.state.warehouse.warehousesForSelect;
          this.$set(this.pagerequest, 'warehouseCode', re.length === 0 ? "" : re[0].id);
          this.warehouses = re;
        });
    }
    async getClients(){
        await this.$store.dispatch({
            type:'client/getListForSelect',
            data: { hasAllItem: true}
        }).then(()=>{
             var re = this.$store.state.client.clientsForSelect;
            this.$set(this.pagerequest, 'clientCode', re.length === 0 ? "" : re[0].code);
            this.clients = re;
        });
    }
    get list() {
        return this.dataPage.list;
    }
    get loading(){
        return this.dataPage.loading;
    }
    get pageSize() {
        return this.dataPage.pageSize;
    }
    get totalCount() {
        return this.dataPage.totalCount;
    }
    get currentPage() {
        return this.dataPage.currentPage;
    }
    pageChange(page: number) {
        this.dataPage.currentPage= page;
        this.pageChangeItems();
    }
    pagesizeChange(pagesize: number) {
        this.dataPage.pageSize= pagesize;
        this.pageChangeItems();
    }
    pageChangeItems() {
        this.dataPage.list = Util.pagingItems(this.reportResult.items, this.dataPage.pageSize, this.dataPage.currentPage);
    }
   async exportToExcel () {
     this.buildPageRequest();
      await this.$store.dispatch({
        type: "report/exportInventoryAgingReport",
        data: this.pagerequest
      });
    }
    buildPageRequest()
    {
       var type = AppConsts.inventoryReportType.admin;
      var clientCode = this.pagerequest.clientCode;
      var warehouseCode =this.pagerequest.warehouseCode;
      if(this.isClient())
      {
        type = AppConsts.inventoryReportType.client;
        clientCode = this.$store.state.session.client.code;
      }
      if(this.isTenant())
      {
        type = AppConsts.inventoryReportType.operation;
        warehouseCode = this.$store.state.session.tenant.tenancyName;
      }
       var data ={
          clientCode:clientCode,
          warehouseCode : warehouseCode,
          sku: this.pagerequest.sku,
          type: type
        };
        return data;
    }
    async getpage(){
        //filters
        await this.$store.dispatch({
            type:'report/getInventoryAgingReport',
            data:this.buildPageRequest()
        })
        .then(result => {
            this.reportResult = result;
            this.dataPage.totalCount = this.reportResult.items.length;
            this.pageChangeItems();
        });
    }
    async searchProductForSelect(keyword)
    {
        if(Util.isEmpty(keyword) || keyword.length<AppConsts.keyWordAtleastLength)
            return;
        this.objectLoading= true;
        this.products = await this.$store.dispatch({
                type:'product/searchProductForSelect',
                data: {
                    clientCode:this.pagerequest.clientCode,
                    keyWord:keyword
                }
        });
        this.objectLoading= false;
    }
    async changeProduct()
    {
       if (Util.isNull(this.pagerequest.sku) || Util.isEmpty(this.pagerequest.sku)) {
            this.productName = '';
            return;
        } 
        var product = _.find(this.products,['sku', this.pagerequest.sku]);
        if(Util.isNull(product))
        {
            this.productName="";
            return;
        }
        this.productName= product.name;
    }
    renderColumn()
    {
        if(this.isClient())
        {
          return clientColumns.concat(columns);
        }
        if(this.isTenant())
        {
          return opsColumns.concat(columns);
        }
        return clientColumns.concat(opsColumns).concat(columns);
    }
    columns=[
      ...this.renderColumn()
    ]
    async created(){
         await this.getWarehouses();
        await this.getClients();
    }
}
